import React from 'react';

import { AuthSilentCallback } from '@klpkonsern/auth-core/routes';
import { Typography } from '@klp/design';
import { Main } from '@klp/layout';

export const SilentCallbackView: React.FC = () => {
    return (
        <AuthSilentCallback>
            <Main withoutHeader={true} withoutSidebar={true} centered={true}>
                <Typography
                    klpHeadingLevel="ONE"
                    translation="auth.authorizing"
                />
            </Main>
        </AuthSilentCallback>
    );
};
